import { api } from "@/frontend/services/api";
import type {
  PaginationRequestDTO,
  TeamResponseDTO,
  TeamsPaginatedResponseDTO,
  TeamQueryDTO,
  CreateTeamRequestDTO,
  UpdateTeamRequestDTO,
  ApiResponse,
} from "@/shared/dto";

const BASE_URL = "/teams/private";

export const teamService = {
  getPaginate: (params?: Partial<PaginationRequestDTO & TeamQueryDTO>) =>
    api.getWithParams<ApiResponse<TeamsPaginatedResponseDTO>>(BASE_URL, params),
  getById: (id: string) => api.get<ApiResponse<TeamResponseDTO>>(`${BASE_URL}/${id}`),
  create: (data: CreateTeamRequestDTO) =>
    api.post<ApiResponse<TeamResponseDTO>>(BASE_URL, data),
  update: (id: string, data: UpdateTeamRequestDTO) =>
    api.put<ApiResponse<TeamResponseDTO>>(`${BASE_URL}/${id}`, data),
  delete: (id: string) => api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
};
